import camelCase from 'lodash/camelCase';

export const normalizeStateName = stateName => {
  camelCase(stateName);
};

export const transformKeys = marketData => {
  return Object.keys(marketData).reduce(
    (accumulator, next) => ({
      ...accumulator,
      [camelCase(next)]: marketData[next],
    }),
    {}
  );
};
